/*
	tcr-shopify-0.1.js - minimal JS for Shopify themes (Debut) 

Changes
	17 March 2019 - Created
*/
var TCR = (function() {
  var MOD = "MyTCR.";
  //LTK.logHide.push( 'MyTCR.' );
  // EXTERNAL functions called Plus a few additions

  function log(text) { LTK.log(text); };
  function info(text) { LTK.info(text); };
  function warning(text) {
    LTK.warning("WARNING: " + text);
  };
  function error(text) {
    LTK.error("ERROR: " + text);
    throw(text);
  };
  function isBlank( obj ) { return LTK.isBlank( obj ); };
  function notBlank( obj ) { return LTK.notBlank( obj ); };
  function cookiesEnabled( ) { return LTK.cookiesEnabled( ); };
  
  //log( MOD + "JS...");

  // Events
  // Globals
  var ELEMENTS = {		// Various document elements
    big_map_lock: '#big-map-lock', big_map_message: '#big-map-message',
    product_teaser_src: '#product-teaser', product_teaser_dst: '.product-teaser',
    product_attributes_src: '#product-attributes', product_attributes_dst: '.product-attributes',
    roaster_teaser_src: '#roaster-teaser', roaster_teaser_dst: '.roaster-teaser',
    roaster_contact_src: '#roaster-contact', roaster_contact_dst: '.roaster-contact',
    shopify_admin: '#admin_bar_iframe'
  };

  /*
	General Error/Message function
  */
  
  function message(text, append) {
    var fn = MOD + "message() "
    //log( fn + "..." );

    if( append == "appendText" || append ){
      $('#tcr-message').append("<br />" + text);
    } else {    
      $("#tcr-message").html(text);
    }
    if ( ! LTK.isBlank( text ) ) {
      //log( fn + "showing message box..." );
      $( "#tcr-message-box" ).show();
      info( fn + text);
    } else {
      //log( fn + "hiding message box..." );
      $( "#tcr-message-box" ).fadeOut();
    }
    //log( fn + "...OK" );

  };

  function closeMessage() {
    var fn = MOD + "closeMessage() "
    $( ".bellows-fade" ).removeClass( "opacity-25" );
    $( "#tcr-message-box" ).fadeOut();
    //log( fn + "closed message box" );
  };
  // buildIconBlock( icon_file, icon_text )
  //	Return the HTML for an icon with text underneath
  
  function buildIconBlock( icon_file, icon_text, text_class ) {
    var fn = MOD + "buildIconBlock() ";
    var _text_class = text_class || "";	// Maybe use: xs-hide
    
    //if( notBlank( text_class ) ) _text_class = text_class;
    
    //log( fn + "file: " + icon_file + ", text: " + icon_text + ", class: " + text_class + "/" + _text_class );
    var html="";

    html ='<div class="block m-auto icon">'
    html += icon_file;
    html += '</div>';
    html += '<div class="grid-item w-auto ' + _text_class + '">'
    html += icon_text;
    html += '</div>';
    return html;
  };

  // buildIconInline( icon_file, icon_text )
  //	Return the HTML for an icon with text to the right

  function buildIconInline( icon_file, icon_text ) {
    var fn = MOD + "buildIconInline() ";

    //log( fn + "file: " + icon_file + ", text: " + icon_text );
    var html="";

    html ='<div class="table-cell">'
    html += icon_file;
    html += '</div>';
    html += '<div class="table-cell v-mid pad-l-10">'
    html += icon_text;
    html += '</div>';
    return html;
  };
  

  //
  // NOTE - all jQuery .bind, .on, etc must be done on existing elements, therefore
  //	put them in document.ready
  
  function bigMapLock() {
    $( ELEMENTS.big_map_lock ).show();
    $( ELEMENTS.big_map_message ).text("Map is locked. Click to enable and zoom");
  };

  function bigMapShow() {
    $( ELEMENTS.big_map_lock ).hide();
    $( ELEMENTS.big_map_message ).text("Map is enabled");
  };

  function initBigMap() {
    var fn = MOD + "initBigMap() ";
    
    bigMapLock();
    $( ELEMENTS.big_map_lock ).click( function() {
      bigMapShow();
    });
    $( ELEMENTS.big_map_message ).click( function() {
      if ( $( ELEMENTS.big_map_lock ).css( "display" ) == "none" ) {
        bigMapLock();
      } else {
        bigMapShow();
      }
    });

  };
  
  //	initTagSelect() - initialise elements for selecting tags
  function initTagSelect( ) {
    var fn = MOD + "initTagSelect() ";
    var current_selection;
    
    $( "label.tcr-select > input" ).click( function() {
      
      //	Grey out ones that are not selected
      $( "label.tcr-select > input:not(:checked) + img" ).fadeTo( 100, 0.3 );
      $( "label.tcr-select > input:checked + img" ).fadeTo( 100, 1.0 );
    });

    // select one tag, build button that links to a tag collection
    $( "label.tcr-select.tag-collection > input" ).click( function() {
      var href_go_base = "/collections/all-coffee/";
      current_selection = this;

      //log( fn + "tag-collection clicked: " + this.value + ":" + this.title );
      $( "#tcr-selected-tags" ).text( "all " + this.title );
      $( "#tcr-select-collection-go" ).attr('href', href_go_base );
      $( "#tcr-select-collection-go" ).show();
    });
    
    //	Special click hander for 'Show me...' button. Needed because button title gets updated
    //	dynamically and tcr-track-link() doesn't use this.  Must also add .ignore-track to button
    
    $( "#tcr-select-collection-go" ).click( function( event ) {
      event.preventDefault();

      tcrTrack( "Clicked button",
               { title: this.text }
               );
      //alert( "Current Selection: " + current_selection.name + ": " + current_selection.title);
      if( current_selection.name == 'method-tags' ) {
        setPreference( 'method', current_selection.title );
      }
      if( current_selection.name == 'milk-tags' ) {
        setPreference( 'milk', current_selection.title );
      }
      //	 No go to the new page
      window.location.href = this.href;
    });

    
    // select multiple tags, build button, search using tags. Ajax preview
    $( "label.tcr-select.tag-query > input" ).click( function() {
      log( fn + "tag-query clicked" );
    
      var selected_tags = $( "label.tcr-select > input:checked" ).map(function() {
        if ( this.value == "no-preference" || this.value == "black" ) {
        } else {
          return this.value;
        }
      }).get();
      
      if( selected_tags.length == 0 ) selected_tags.push('*');
      
      $( "#tcr-selected-tags" ).text( selected_tags.join( ' and ' ) );
      var query_url = href_go_base + "/" + selected_tags.join( '+' );
      log( fn + "Query: " + query_url );
      $.ajax({
				url: "/search",
                data: {
                  q: "tag:" + selected_tags.join( ' tag:' ),
					type: "product",
					view: "json",
                },
				dataType: "json",
				success: function( data, textStatus, jqXHR ) {
                  //log( fn + "Ajax textStatus: " + textStatus );
                  //log( fn + "Ajax data: " + JSON.stringify(data) );
                  var max_items = 10;
                  var html;
                  
                  if ( data.length > max_items ) {
                    html = "<div>More than " + max_items + " results</div>";
                    $( "#tcr-select-query-go" ).show();

                  } else if ( data.length == 0 ) {
                    html = "<div class='h2'>Sorry no coffees match: " +
                      $( "#tcr-selected-tags" ).text() +
                      "</div>";
                    $( "#tcr-select-query-go" ).hide();
                  } else {
                    html = "<div>" + data.length + " results</div>";
                    $( "#tcr-select-query-go" ).show();
                  }

                  jQuery.each( data, function(index, item) {
                    if ( index < max_items ) {
                    	html += "<a href='" + item.url + "'>" + item.title + "</a>, ";
                    }
                  });
                  if ( data.length > max_items ) {
                    html += "<div>etc...</div>";
                  }
                  $( "#tcr-selected-results" ).html(html);
                }
			});
      
    });
    
    $( "#tcr-select-query-go" ).click( function( event ) {

      var selected_tags = $( "label.tcr-select > input:checked" ).map(function() {
          //console.log( "Selected tag: " + this.name + ": " + this.title);
        if( this.name == 'method-tags' ) {
          setPreference( 'method', this.title );
        }
        if( this.name == 'milk-tags' ) {
          setPreference( 'milk', this.title );
        }
        if ( this.value == "no-preference" || this.value == "black" ) {
        } else {
          return this.value;
        }
      }).get();
      var href_go = href_go_base + "/" + selected_tags.join( '+' ) + "#scroll-top";

      $( "#tcr-select-go" ).attr('href', href_go );
      log( fn + "Selected tags: " + selected_tags.join( '+' ) );
    });
    
  };

  
  $(document).ready(function() {
    var fn = MOD + "document.READY() ";

    log( fn + "Initialising handlers...");

    if ( Shopify.template == "page.big-list" ) {
      initBigMap();
    }
    
    //	Hide Shopify Admin iFrame on print
    jQuery( ELEMENTS.shopify_admin ).addClass( "no-print" );
    
    //	COMMON items for all pages
    $('.bellows-no-fade').bellows( {
      open: function(e, ui) { 
        //tcrTrackOpenMenu( ui );
      },
      close: function(e, ui) { 
        //tcrTrackCloseMenu( ui );
      }
    } );
    
    $('.bellows').bellows( {
      open: function(e, ui) { 
        $( '.bellows-fade' ).addClass( "opacity-25" );
      },
      close: function(e, ui) { 
        $( '.bellows-fade' ).removeClass( "opacity-25" );
      }
      
    });
    $( "#tcr-message-close" ).click( function() {
      closeMessage();
    });
    
    // Initialise tag selection event handlers
    initTagSelect();

    log( fn + "Initialising handlers...OK");

  });

  /*
  	MAIN
  */
  var main = function() {
    var fn = MOD + "main() ";
  };
  
  main();


  //log( MOD + "JS...OK")
  //	Public methods

  return {
    log: log,
    info: info,
    message: message,
    closeMessage: closeMessage,
    warning: warning,
    error: error,
    buildIconBlock: buildIconBlock,
    buildIconInline: buildIconInline
  };

})();	// End of TCR.shopify Module - IFFE pattern
